export default function setupAxios(axios: any, store: any) {
	axios.interceptors.request.use(
		(config: any) => {
			const {
				auth: { accessToken },
			} = store.getState();

			const requestUrl = String(config?.url || "");
			// Public auth endpoints must stay unauthenticated.
			// Sending Authorization here can trigger CORS rejection on integration API.
			const isPublicAuthRequest =
				requestUrl.includes("/auth/login") ||
				requestUrl.includes("/auth/register") ||
				requestUrl.includes("/auth/otp") ||
				requestUrl.includes("/auth/forgot-password");

			if (accessToken && !isPublicAuthRequest) {
				config.headers.Authorization = `Bearer ${accessToken}`;
			}

			return config;
		},
		(err: any) => Promise.reject(err)
	);

	axios.interceptors.response.use(
		(response: any) => {
			return response;
		},
		(error: any) => {
			// A 401 from a public auth endpoint (e.g. an expired OTP challenge)
			// is handled by that screen; there is no session to log out of.
			const requestUrl = String(error?.config?.url || "");
			const isPublicAuthRequest =
				requestUrl.includes("/auth/login") ||
				requestUrl.includes("/auth/register") ||
				requestUrl.includes("/auth/otp") ||
				requestUrl.includes("/auth/forgot-password");

			if (401 === error?.response?.status && !isPublicAuthRequest) {
				window.location.replace("/logout");
			} else {
				return Promise.reject(error);
			}
		}
	);
}
